import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { QueryResponse } from '../../../ReactQuery/useQuery';
import type {
  FetchPackageVersionVulnerabilityRemediationResponse,
  FetchPackageVersionVulnerabilityResponse,
  SelectedVuln,
} from '../../../../shared/organizationPackages/response';

async function fetchSelectedVuln(vulnId: string, revisionId: string): Promise<QueryResponse<SelectedVuln>> {
  const [vulnResponse, remediationResponse] = await Promise.all([
    get<FetchPackageVersionVulnerabilityResponse>(`/api/vulns/${encodeURIComponent(vulnId)}`, true),
    get<FetchPackageVersionVulnerabilityRemediationResponse>(
      `/api/vulns/${encodeURIComponent(vulnId)}/revisions/${nuc(revisionId)}/remediation-guidance`,
      true,
    ),
  ]);

  if (!vulnResponse.data || !remediationResponse.data) {
    throw new Error('Selected vulnerability response was missing data.');
  }

  return Object.assign(vulnResponse, {
    data: { ...vulnResponse.data, ...remediationResponse.data },
  });
}

export const getSelectedVulnQueryKey = (vulnId: string | null, revisionId: string | null) => [
  'vulns',
  vulnId,
  'with-remediation',
  revisionId,
];

export default function useSelectedVuln(vulnId: string | null, revisionId: string | null) {
  return useQuery<SelectedVuln>({
    queryKey: getSelectedVulnQueryKey(vulnId, revisionId),
    queryFn: () => {
      if (!vulnId || !revisionId) {
        throw new Error('Selected vulnerability query needs a vulnerability and a revision.');
      }
      return fetchSelectedVuln(vulnId, revisionId);
    },
    enabled: Boolean(vulnId && revisionId),
    staleTime: 1000 * 60 * 5,
  });
}
